import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "customer-reviews-details-group" }

import CustomerReviewsBar from '@lmt-rpb/CustomerReviewsBar/CustomerReviewsBar.vue';
import { type PropType, ref } from 'vue';
import { numberFormat } from '@/js/utils/numberUtils';
import ShowMoreToggle from '@lmt-rpb/Atoms/ShowMoreToggle/ShowMoreToggle.vue';
import { storeToRefs } from 'pinia';
import { useBreakpointStore } from 'src/store/breakpointsStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerReviewsDetailsGroup',
  props: {
	details: {
		type: Object as PropType<Record<string, number>>,
		required: true,
		validator(value: Record<string, number>) {
			return !!Object.keys(value).length;
		},
	},
	maxValue: {
		type: Number,
		required: false,
		default: 6,
	},
},
  setup(__props) {

const props = __props;

const isOpen = ref(false);

const { isMinTablet } = storeToRefs(useBreakpointStore());

const calculateValue = (value: number): string => {
	return numberFormat(Math.max(0, Math.min(value, props.maxValue)));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["customer-reviews-details-group__wrap", { open: isOpen.value }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.details, (value, key, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index + key,
          class: "customer-reviews-details-group__item"
        }, [
          _createVNode(CustomerReviewsBar, {
            value: value,
            title: key,
            rating: calculateValue(value)
          }, null, 8 /* PROPS */, ["value", "title", "rating"])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ], 2 /* CLASS */),
    (!_unref(isMinTablet))
      ? (_openBlock(), _createBlock(ShowMoreToggle, {
          key: 0,
          "onShowMoreToggle:onToggle": _cache[0] || (_cache[0] = (e) => (isOpen.value = e))
        }))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})